import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { ApiConsumes, ApiHeader, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { FeedbackDTO } from './dto/feedback.dto';
import { AllFeedBackResponseModel, FeedBackResponseModel } from './dto/feedback-response-module';
import { FeedbackService } from './feedback.service';

@ApiTags('Feedback')
@Controller('feedback')
export class FeedbackController {

    constructor (
        private feedbackService:FeedbackService,
    ) {}

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createFeedback')
    @ApiQuery({name:'apiVersion'})
    async createFeedback(@Query() queryParams, @Body() feedDto:FeedbackDTO, @Req() request: Request): Promise<FeedBackResponseModel> {
        try {
            return await this.feedbackService.createFeedback(queryParams, feedDto,request);
        } catch (error) {
            return errorHandler(FeedBackResponseModel, error);
        }
    }

    /* @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getFeedback')
    @ApiQuery({name:'apiVersion'})
    async getFeedback(@Query() queryParams, @Req() request:Request):Promise<AllFeedBackResponseModel> {
        try {
            return await this.EventService.getAllEvents(eventPagDto, userId, request);
        } catch (error) {
            return errorHandler(AllEventsResponseModel, error);
        }
    } */

    }
